
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import CardRh from "@/components/cards/ManzaCard.vue";
import Multiselect from "@vueform/multiselect";
import EspacoService from "@/service/v1/sigap/EspacoService";
import AgendamentoEspacoService from "@/service/v1/sigap/AgendamentoEspacoService";
import MatriculaService from "@/service/v10/sigap/MatriculaService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { User } from "@/store/modules/AuthModule";
import $ from "jquery";
import Swal from "sweetalert2";

const authStore = namespace("auth");

@Options({
    name: "P4AgendamentoEspaco",
    components: { CardRh, Multiselect },
})
export default class P4AgendamentoEspaco extends Vue {
    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public currentUser!: User;

    public espacoService = new EspacoService();
    public agendamentoService = new AgendamentoEspacoService();
    public matriculaService = new MatriculaService();
    public processando = false;
    public espacos: any = [];
    public agendamentos: any = [];
    public espacosAgendamentosExpandidos: any = {};
    public matriculas: any = [];
    public matriculaAtual: any = null;
    public status: any = null;
    public dataFiltro = "";
    public modal_cadastro = "modal_p4_agendamento_espaco";

    public espacoSelecionado: any = null;
    public dataAgendamento: any = null;
    public horaInicio: any = null;
    public horaFim: any = null;
    public statusId: any = null;
    public nomeInstrucao: any = null;
    public nomeInstrutor: any = null;
    public pelotao: any = null;
    public turma: any = null;
    public telefoneContato: any = null;

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.P4], this.perfis);
    }

    get dataFiltroMenorQueHoje(): boolean {
        return this.normalizarDataComparacao(this.dataFiltro) < this.getDataAtual();
    }

    get statusSelect() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    
    get turmasSelect() {
        if (this.matriculas) {
            return this.matriculas.map((item) => {
                return { value: item.turma, label: item.turma.descricao };
            });
        }
        return [];
    }

    created() {
        this.dataFiltro = this.getDataAtual();
        this.buscarStatus();
        this.buscarEspacos();
        this.getMatriculaAtual();
    }

    public getDataAtual(): string {
        const data = new Date();
        const mes = String(data.getMonth() + 1).padStart(2, "0");
        const dia = String(data.getDate()).padStart(2, "0");
        return `${data.getFullYear()}-${mes}-${dia}`;
    }

    public buscarStatus() {
        this.agendamentoService.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.statusId = this.status?.[0]?.id ?? null;
            })
            .catch(() => {
                this.status = null;
            });
    }

    
    public getMatriculaAtual() {
        this.matriculaService.getAll("Skip=0&Take=1&isMatriculaAtual=true")
            .then(response => {
                const matriculas = response.data ?? response;
                this.matriculas = Array.isArray(matriculas) ? JSON.parse(JSON.stringify(matriculas)) : [];
                this.matriculaAtual = this.matriculas[0] ?? null;
                this.turma = this.matriculaAtual?.turma ?? null; 
                this.pelotao = this.matriculaAtual?.pelotao ?? 0; 
            })
            .catch(() => {
                this.matriculas = [];
                this.matriculaAtual = null;
                this.turma = null;
                this.pelotao = 0;
            });
    }

    public buscarEspacos() {
        this.processando = true;
        this.espacoService.getAll("Skip=0&Take=500&status=1")
            .then(response => {
                this.espacos = response.data ?? response;
                this.buscarAgendamentos();
            })
            .catch(error => {
                this.processando = false;
                this.espacos = [];
                SiteUtils.toastErro("Error!", error?.data?.message ?? "Nao foi possivel buscar os espacos.");
            });
    }

    public getParametrosBuscarAgendamentos(): string {
        const parametros = new URLSearchParams();
        const listStatus = [1, 2]; 
        parametros.append("Skip", "0");
        parametros.append("Take", "2000");
        parametros.append("data", this.dataFiltro);

        listStatus.forEach((status) => {
            parametros.append("listStatus", String(status));
        });

        return parametros.toString();
    }

    public buscarAgendamentos() {
        if (!this.dataFiltro) {
            return;
        }

        this.processando = true;
        this.agendamentoService.getAll(this.getParametrosBuscarAgendamentos())
            .then(response => {
                this.agendamentos = response.data ?? response;
                this.espacosAgendamentosExpandidos = {};
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
                this.agendamentos = [];
                SiteUtils.toastErro("Error!", error?.data?.message ?? "Nao foi possivel buscar os agendamentos.");
            });
    }

    public agendamentosPorEspaco(espacoId) {
        if (!this.agendamentos) {
            return [];
        }

        return this.agendamentos
            .filter((agendamento) => {
                const id = agendamento.espacoLocavel?.id ?? agendamento.espacoLocavelId;
                return Number(id) === Number(espacoId);
            })
            .sort((agendamentoA, agendamentoB) => {
                const horaA = this.formatarHora(agendamentoA?.horaInicio) || "99:99";
                const horaB = this.formatarHora(agendamentoB?.horaInicio) || "99:99";
                return horaA.localeCompare(horaB);
            });
    }

    public agendamentosEspacoExpandido(espacoId) {
        return !!this.espacosAgendamentosExpandidos[espacoId];
    }

    public agendamentosVisiveisPorEspaco(espacoId) {
        const agendamentos = this.agendamentosPorEspaco(espacoId);

        if (this.agendamentosEspacoExpandido(espacoId)) {
            return agendamentos;
        }

        return agendamentos.slice(0, 2);
    }

    public alternarVisualizacaoAgendamentos(espacoId) {
        this.espacosAgendamentosExpandidos = {
            ...this.espacosAgendamentosExpandidos,
            [espacoId]: !this.agendamentosEspacoExpandido(espacoId),
        };
    }

    public abrirCadastro(espaco) {
        this.espacoSelecionado = espaco;
        this.dataAgendamento = this.dataFiltro;
        this.horaInicio = null;
        this.horaFim = null;
        this.statusId = this.status?.[0]?.id ?? this.statusId;
        this.nomeInstrucao = null;
        this.nomeInstrutor = null;
        this.turma = this.matriculaAtual?.turma ?? this.turma;
        this.pelotao = this.matriculaAtual?.pelotao ?? 0;
        this.telefoneContato = null;
    }

    public formatarHora(valor) {
        return valor ? String(valor).substring(0, 5) : "";
    }

    public descricaoTurmaAgendamento(agendamento) {
        const descricaoTurma = agendamento.turma?.descricao
            ? String(agendamento.turma.descricao).substring(0, 35)
            : "";
        return descricaoTurma ? ` ${agendamento.pelotao}º pel - ${descricaoTurma}` : "";
    }

    public formatarStatus(status) {
        return status?.nome ? status.nome.replaceAll("_", " ") : "";
    }

    public mostrarDadosAgendamento(agendamento) {
        Swal.fire({
            title: "Dados do agendamento",
            icon: "info",
            html: this.montarHtmlDadosAgendamento(agendamento),
            width: "1560px",  
            confirmButtonText: "Fechar",
            customClass: {
                content: "swal-agendamento-content",
            },
        });
    }

    public montarHtmlDadosAgendamento(agendamento) {
        const linhas = this.getLinhasDadosAgendamento(agendamento);

        return `
            <div class="swal-agendamento-details">
                ${linhas.map((item) => `
                    <div class="swal-agendamento-row">
                        <span>${item.label}</span>
                        <strong>${item.valor}</strong>
                    </div>
                `).join("")}
            </div>
        `;
    }

    public getLinhasDadosAgendamento(agendamento) {
        const linhas: any[] = [ 
            { label: "Data", valor: SiteUtils.formatData(agendamento?.data ?? this.dataFiltro) },
            { label: "Hora Inicio", valor: this.formatarHora(agendamento?.horaInicio) },
            { label: "Hora Fim", valor: this.formatarHora(agendamento?.horaFim) },
            { label: "Espaco", valor: agendamento?.espacoLocavel?.nome ?? agendamento?.espacoLocavel ?? agendamento?.espacoLocavelId },
            { label: "Turma", valor: this.descricaoTurmaAgendamento(agendamento) },
            { label: "Instrucao", valor: agendamento?.nomeInstrucao },
            { label: "Instrutor", valor: agendamento?.nomeInstrutor },
            { label: "Pelotao", valor: agendamento?.pelotao },
            { label: "Telefone", valor: agendamento?.telefoneContato },
            // { label: "Status", valor: this.formatarStatus(agendamento?.status) },
        ];
 
        return linhas.filter((item) => item.valor !== null && item.valor !== undefined && item.valor !== "");
    }
 
 

    public normalizarDataComparacao(data) {
        if (!data) {
            return "";
        }

        if (data instanceof Date) {
            const mes = String(data.getMonth() + 1).padStart(2, "0");
            const dia = String(data.getDate()).padStart(2, "0");
            return `${data.getFullYear()}-${mes}-${dia}`;
        }

        const dataTexto = String(data);
        if (/^\d{4}-\d{2}-\d{2}/.test(dataTexto)) {
            return dataTexto.substring(0, 10);
        }

        return dataTexto;
    }

    public agendamentoPertenceAoUsuario(agendamento) {
        const usuarioCriador = agendamento.usuarioId ?? agendamento.requisitanteId;
        const usuarioLogado = (this.currentUser as any)?.identificador ?? this.currentUser?.id;

        return usuarioCriador && usuarioLogado && String(usuarioCriador) === String(usuarioLogado);
    }

    public agendamentoCriadoPeloUsuario(agendamento) {
        const dataAgendamento = this.normalizarDataComparacao(agendamento.data ?? this.dataFiltro);
        const dataAtual = this.getDataAtual();

        return this.agendamentoPertenceAoUsuario(agendamento) && dataAgendamento >= dataAtual;
    }

    public excluirAgendamento(agendamento) {
        if (!this.agendamentoCriadoPeloUsuario(agendamento)) {
            return;
        }

        SiteUtils.alertConfimacao("Confirma a exclusao do agendamento?", "",
            () => {
                this.processando = true;
                this.agendamentoService.excluirP4(agendamento.id)
                    .then(() => {
                        SiteUtils.toastSucesso("Agendamento excluido com sucesso!");
                        this.processando = false;
                        this.buscarAgendamentos();
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro("Error!", error?.data?.message ?? "Nao foi possivel excluir o agendamento.");
                    });
            }
        );
    }

    public getDadosAgendamento() {
        const dados: any = {};
        dados.data = this.dataAgendamento;
        dados.horaInicio = this.horaInicio;
        dados.horaFim = this.horaFim;
        dados.status = this.statusId;
        dados.espacoLocavelId = this.espacoSelecionado?.id;
        dados.turmaId = this.turma?.id ?? this.turma ?? null;
        dados.nomeInstrucao = this.nomeInstrucao;
        dados.nomeInstrutor = this.nomeInstrutor;
        dados.pelotao = this.pelotao;
        dados.telefoneContato = this.telefoneContato;
        return dados;
    }

    public salvarAgendamento() {
        if (this.processando || !this.hasPermissao) {
            return;
        }

        if (!this.dataAgendamento || !this.horaInicio || !this.horaFim || !this.statusId || !this.espacoSelecionado?.id || !this.nomeInstrucao || !this.nomeInstrutor || (!this.pelotao && this.pelotao !== 0)|| !this.telefoneContato) {
            SiteUtils.toastErro("Error!", "Preencha todos os campos obrigatorios.");
            return;
        }

        this.processando = true;
        this.agendamentoService.cadastrar(this.getDadosAgendamento())
            .then(response => {
                SiteUtils.toastSucesso("Cadastrado com sucesso!", response.message);
                this.processando = false;
                $("[data-bs-dismiss='modal']").trigger({ type: "click" });
                this.buscarAgendamentos();
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro("Error!", error?.data?.message ?? "Nao foi possivel cadastrar o agendamento.");
            });
    }
}
